<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex" style="gap: 10px;">
        <v-icon :color="plan.color ? plan.color.hex : null" small>
          fiber_manual_record
        </v-icon>
        {{ `${plan.display_name} (${plan.currency.code})` }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row no-gutters>
          <!------------------------------------------>
          <!-- NAME ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="6">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.view.plan.name") }}</span
            > -->
            <v-text-field
              :value="localPlan.display_name"
              :label="$t('pricing_model.view.plan.name')"
              class="rounded-lg mt-1"
              outlined
              dense
              readonly
            >
            </v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- FREQUENCY ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.view.plan.frequency") }}</span
            > -->
            <v-text-field
              :value="frequencyText"
              :label="$t('pricing_model.view.plan.frequency')"
              class="rounded-lg mt-1"
              hide-details
              outlined
              dense
              readonly
            ></v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- ID ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" md="3" class="px-4">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.view.plan.id") }}</span
            > -->
            <v-text-field
              v-model="localPlan.id"
              disabled
              label="ID"
              class="rounded-lg mt-1"
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- DESCRIPTION ----------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <!-- <span
              class="subtitle-2 grey--text text--darken-2 font-weight-regular"
              >{{ $t("pricing_model.view.plan.description") }}</span
            > -->
            <v-text-field
              :value="localPlan.description"
              :label="$t('pricing_model.view.plan.description')"
              class="rounded-lg mt-1"
              outlined
              dense
              readonly
            >
            </v-text-field>
          </v-col>
          <!------------------------------------------>
          <!-- LIMITS TABLE ----------------------------->
          <!------------------------------------------>
          <v-col cols="12" v-if="localPlan.has_limits_table">
            <v-row no-gutters>
              <v-col cols="12">
                <span class="subtitle-2 grey--text text--darken-2">
                  {{
                    $t('pricing_model.view.plan.limits_table.registers.title')
                  }}
                </span>
                <!------------------------------------------>
                <!-- LIMITS REGISTERS ----------------------------->
                <!------------------------------------------>
                <v-col cols="12" v-if="!pricingModelVersion2">
                  <span
                    class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >
                    {{
                      $t('pricing_model.view.plan.limits_table.registers.title')
                    }}
                  </span>
                  <v-row>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.registers.from'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.offset_registers"
                        readonly
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.registers.to'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.limit_registers"
                        readonly
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <!------------------------------------------>
                <!-- LIMITS INCOMES ----------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <span
                    class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >
                    {{
                      $t('pricing_model.view.plan.limits_table.incomes.title')
                    }}
                  </span>
                  <v-row>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t(
                            'pricing_model.view.plan.limits_table.incomes.from'
                          )
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.offset_incomes"
                        readonly
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="mt-4 d-flex">
                      <span
                        class="subtitle-2 mr-4 mt-3 grey--text text--darken-2 font-weight-regular"
                      >
                        {{
                          $t('pricing_model.view.plan.limits_table.incomes.to')
                        }}
                      </span>
                      <v-text-field
                        :value="localPlan.limit_incomes"
                        readonly
                        class="rounded-lg"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <!------------------------------------------>
              <!-- AMOUNT ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6" v-if="!plan.custom_amount">
                <!-- <span
                  class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >{{ $t("pricing_model.view.plan.amount") }}</span
                > -->
                <v-text-field
                  :value="localPlan.amount"
                  :label="
                    `${$t('pricing_model.view.plan.amount')} ${
                      localPlan.currency.code
                    } (${localPlan.currency.symbol})`
                  "
                  class="rounded-lg mt-1"
                  outlined
                  dense
                  readonly
                >
                </v-text-field>
              </v-col>
              <!------------------------------------------>
              <!-- FEE_PERCENTAGE ----------------------------->
              <!------------------------------------------>
              <v-col cols="12" md="6" v-if="!plan.custom_fee">
                <!-- <span
                  class="subtitle-2 grey--text text--darken-2 font-weight-regular"
                  >{{ $t("pricing_model.view.plan.fee_percentage") }}</span
                > -->
                <v-text-field
                  :value="localPlan.fee_percentage"
                  :label="`${$t('pricing_model.view.plan.fee_percentage')} %`"
                  class="rounded-lg mt-1"
                  outlined
                  dense
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!------------------------------------------>
          <!-- AUTOMATION ----------------------------->
          <!------------------------------------------>
          <v-col
            cols="12"
            v-if="!plan.custom_automation && plan.plan_automation"
          >
            <v-card class="rounded-lg" flat style="border: 1px solid #BCBCBC;">
              <v-card-title
                class="subtitle-1 grey--text text--darken-2 font-weight-regular"
              >
                {{ $t('pricing_model.view.plan.automation') }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :value="localPlan.plan_automation.description"
                      :label="$t('pricing_model.view.plan.description')"
                      class="rounded-lg mt-1"
                      outlined
                      dense
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      :value="localPlan.plan_automation.email_cost"
                      :label="
                        `${$t('pricing_model.view.plan.email_cost')}  ${
                          localPlan.currency.code
                        } (${localPlan.currency.symbol})`
                      "
                      class="rounded-lg mt-1"
                      outlined
                      dense
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ViewPlan',
  props: {
    plan: { type: Object, required: true, default: () => {} }
  },
  data() {
    return {
      valid: true,
      frequencies: [
        {
          text: this.$t('pricing_model.view.plan.frequencies.monthly'),
          value: 1
        },
        {
          text: this.$t('pricing_model.view.plan.frequencies.yearly'),
          value: 2
        }
      ],
      localPlan: null
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState({
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel
    }),
    pricingModelVersion2() {
      return this.pricingModel.version === 2
    },
    frequencyText() {
      return this.localPlan.frequency === 1
        ? this.$t('pricing_model.view.plan.frequencies.monthly')
        : this.$t('pricing_model.view.plan.frequencies.yearly')
    }
  },
  methods: {
    init() {
      this.plan.id = parseInt(this.plan.id)
      this.plan.frequency = parseInt(this.plan.frequency)
      this.localPlan = {
        ...this.plan,
        frequency: parseInt(this.plan.frequency),
        id: parseInt(this.plan.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
